import React, { Fragment } from "react";

import "./MainCard.css";

const MainCard = (props) => (
  <Fragment>
    <div className="mn-grid__row">
      <div className="mn-grid__col">
        <div className="mn-card">
          <div className="mn-card__header">
            <div className="mn-card__title">{props.cardTitle}</div>
          </div>
          <div className="mn-card__body">{props.children}</div>
        </div>
      </div>
    </div>
  </Fragment>
);

export default MainCard;
